import React, { useState, useRef, useEffect } from "react";
import axios from 'axios';
import { Cookies } from '../../../../index.js';
import { RingLoader, MoonLoader } from "react-spinners";
import { useNavigate, NavLink, Link } from 'react-router-dom';
import { alert_error, alert_success } from "../../../../AppContext.js";
import { Helmet } from "react-helmet";
import BitmediaAd from '../../../mission/bitmedia';
import { useParams } from 'react-router-dom';
import Mission_edit from "./../admin/mission_edit";
import Faucet_home from '../../../mission/faucet_home.jsx';
import DataJop from './data_jop';
import Language_i18 from '../../../../js/useNationalLanguage.jsx';
import AdSense from 'react-adsense';
import { isLocalHost } from '../../../../shared/host_utils.js';

function Faucettraffic({ category: categoryProp }) {
    const { i18n, lang } = Language_i18();
    const { slug_2 } = useParams();
    const [ip_address_v4, set_ip_address_v4] = useState('');
    const navigate = useNavigate();
    const [dalaythongtin, setdalaythongtin] = useState(false);
    const [htoken, sethtoken] = useState('');
    const [gtoken, setgtoken] = useState('');
    const [data, setdata] = useState('');
    const [nutxuly, setnutxuly] = useState(0);
    const [service, setservice] = useState("");
    const [category, setcategory] = useState("");
    const [mission, setmisson] = useState('');
    const [type_api, settype_api] = useState('');
    const [data_edit, set_data_edit] = useState('');
    const [nutorder, setnutorder] = useState();
    const [dataToSend, setdataToSend] = useState(false);
    const [link, setlink] = useState(false);
    const national_market = Cookies.get('national_market') || 'vi';

    // Định nghĩa json_faucet
    const json_faucet = {
        vi: {
            confirm: "Vui lòng ấn confirm",
            wait: "Bạn hãy đợi vài giây để app xử lý nhé",
            download_app: "Vui lòng tải app để làm jop này",
            captcha_error: "Lỗi captcha vui lòng thử lại",
            thank_you: "Cảm ơn bạn đã ủng hộ",
            error_occurred: "Đã xảy ra lỗi vui lòng nhập lại",
            level_up: "Thăng cấp để mở khóa nhiệm vụ ẩn"
        },
        en: {
            confirm: "Please confirm",
            wait: "Please wait a few seconds for the app to process",
            download_app: "Please download the app to do this job",
            captcha_error: "Captcha error, please try again",
            thank_you: "Thank you for your support",
            error_occurred: "An error occurred, please try again",
            level_up: "Level up to unlock hidden missions"
        }
    };

    function normalizeTextField(value) {
        if (value === null || value === undefined) return '';
        if (typeof value === 'string') return value;
        if (typeof value === 'object') {
            try {
                return JSON.stringify(value);
            } catch (e) {
                return String(value);
            }
        }
        return String(value);
    }

    function normalizeMissionItem(item) {
        if (!item || typeof item !== 'object') return item;
        return {
            ...item,
            name: normalizeTextField(item.name),
            description: normalizeTextField(item.description),
        };
    }

    function normalizeMissionList(list) {
        return Array.isArray(list) ? list.map(normalizeMissionItem) : list;
    }

    function handleSubmit(value) {
        console.log(value.id);
        laymisson(value.id);
        setdataToSend(false);
        setservice(value.id);
        settype_api(value.type_api);
        setnutorder(json_faucet[lang]?.confirm); // Thay thế chuỗi cứng
        setTimeout(() => {
            showcaptcha(value.id);
        }, 300);
    };

    useEffect(() => {
        const myCookieValue = Cookies.get('apikey');
        axios.get('https://hust.media/jop/telegram/checkxacthuc.php?apikey=' + myCookieValue)
            .then((response) => {
                testFunction(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    }, []);

    function updateJson1(json1, json2) {
        let updatedJson1 = [...json1];
        json2.forEach(item2 => {
            const index = updatedJson1.findIndex(item1 => item1.id === item2.id);
            if (index !== -1) {
                updatedJson1[index] = item2;
            } else {
                updatedJson1.push(item2);
            }
        });
        return updatedJson1;
    }

    function laymisson(value) {
        const myCookieValue = Cookies.get('apikey');
        setmisson(false);
        if (value === undefined) {
            axios.get('https://nginx.hust.media/go/mission/p2p_link/checklink', {
                params: {
                    apikey: myCookieValue,
                    category: category,
                    service: service
                }
            })
                .then(response => {
                    const normalizedData = normalizeMissionList(response.data);
                    console.log(normalizedData);
                    const updatedJson1 = updateJson1(data, normalizedData);
                    setdata(updatedJson1);
                    console.log(updatedJson1);
                    setdalaythongtin(true);
                })
                .catch(error => {
                    alert_error(error);
                });
        } else {
            axios.get('https://nginx.hust.media/go/mission/p2p_link/checklink', {
                params: {
                    apikey: myCookieValue,
                    category: category,
                    service: value
                }
            })
                .then(response => {
                    const normalizedData = normalizeMissionList(response.data);
                    console.log(normalizedData);
                    if (normalizedData?.[0]?.type_api == 'window.location.href') {
                        window.location.href = normalizedData[0].api_categorymini;
                    }
                    const updatedJson1 = updateJson1(data, normalizedData);
                    setdata(updatedJson1);
                    setdalaythongtin(true);
                })
                .catch(error => {
                    alert_error(error);
                });
        }
    };

    function laythongtin(value) {
        setmisson(false);
        const myCookieValue = Cookies.get('apikey');
        axios.get('https://nginx.hust.media/go/mission/p2p_link/checklink', {
            params: {
                apikey: myCookieValue,
                category: value
            }
        })
            .then(response => {
                const normalizedData = normalizeMissionList(response.data);
                console.log(normalizedData);
                setdata(normalizedData);
                setdalaythongtin(true);
            })
            .catch(error => {
                alert_error(error);
            });
    };

    const startjop = (event) => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                document.removeEventListener('visibilitychange', handleVisibilityChange);
                laymisson();
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => { };
    };

    useEffect(() => {
        setdalaythongtin(false);
        reload_camp(categoryProp || slug_2);
    }, [slug_2, categoryProp]);

    const reload_camp = (categoryValue) => {
        if (categoryValue == 'videos_check' || categoryValue == 'p2p_mmo' || categoryValue == 'offerwall' || categoryValue == 'option_viewer' || categoryValue == 'rollup' || categoryValue == 'rewarded_ads' || categoryValue == 'hustadmin') {
            laythongtin(categoryValue);
            setcategory(categoryValue);
        } else {
            const category = '';
            laythongtin(category);
            setcategory(category);
        }
    };

    function showcaptcha(value) {
        setdataToSend(true);
    };

    useEffect(() => {
        axios
            .get("https://api.ipify.org/?format=json")
            .then((response) => {
                if (response.data.ip) {
                    set_ip_address_v4(response.data.ip);
                }
            })
            .catch((error) => {
                alert_error(error);
            });
    }, []);

    const receiveDataFromChild = (dataFromChild) => {
        console.log(123);
        console.log(dataFromChild);
        const maxLength = 200;
        setnutxuly(1);
        setnutorder(json_faucet[lang]?.wait); // Thay thế chuỗi cứng
        const myCookieValue = Cookies.get('apikey');
        const device_id = Cookies.get('device_id');
        if (type_api.includes('only_app')) {
            console.log(type_api);
            const userAgent = navigator.userAgent.toLowerCase();
            if (userAgent.includes("hustmedianative") || userAgent.includes("hustmedia-android") || isLocalHost(window.location.hostname) || window.location.hostname == 'tecom.pro') {
            } else {
                alert_error(json_faucet[lang]?.download_app); // Thay thế chuỗi cứng
                navigate('/reactapp/thankiu');
                setnutxuly(0);
                return;
            }
        }
        if (dataFromChild.gtoken) {
            if (dataFromChild.gtoken.length > maxLength) {
                let data = JSON.stringify({
                    "gtoken": dataFromChild.gtoken,
                    "service": service,
                    "apikey": myCookieValue,
                    "ip_address_v4": ip_address_v4,
                    "national_market": national_market
                });
                getlink(data);
            } else {
                alert_error(json_faucet[lang]?.captcha_error); // Thay thế chuỗi cứng
            }
        } else if (dataFromChild.htoken) {
            if (dataFromChild.htoken.length > maxLength) {
                let data = JSON.stringify({
                    "htoken": dataFromChild.htoken,
                    "service": service,
                    "apikey": myCookieValue,
                    "ip_address_v4": ip_address_v4,
                    "national_market": national_market
                });
                getlink(data);
            } else {
                setnutxuly(0);
                alert_error(json_faucet[lang]?.captcha_error); // Thay thế chuỗi cứng
            }
        } else if (dataFromChild.iv) {
            if (dataFromChild.iv.length > 20) {
                let data = JSON.stringify({
                    "crypto": dataFromChild,
                    "service": service,
                    "apikey": myCookieValue,
                    "device_id": device_id,
                    "ip_address_v4": ip_address_v4,
                    "national_market": national_market
                });
                getlink(data);
            } else {
                setnutxuly(0);
                alert_error(json_faucet[lang]?.captcha_error); // Thay thế chuỗi cứng
            }
        } else {
            setnutxuly(0);
            alert_error(json_faucet[lang]?.captcha_error); // Thay thế chuỗi cứng
        }
    };

    function getlink(data) {
        const parsedData = JSON.parse(data);
        if (parsedData.service) {
            Cookies.set('id_data_view', parsedData.service, { expires: 1 / 24 });
            Cookies.set('category_view', category, { expires: 1 / 24 });
            console.log('đã set category_view cookies');
        }
        let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: 'https://nginx.hust.media/go/mission/p2p_link/getlink',
            headers: {
                'Content-Type': 'application/json',
            },
            data: data,
            timeout: 35000,
        };
        axios.post(config.url, config.data, config)
            .then((response) => {
                setnutxuly(0);
                testFunction(response);
            })
            .catch((error) => {
                setnutxuly(0);
                alert_error(error);
            });
    };

    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutxuly(0);
        if (status == 1) {
            alert_success(message);
            setnutorder(json_faucet[lang]?.thank_you); // Thay thế chuỗi cứng
            setmisson(true);
            setlink(info.link);
        } else if (status == 0) {
            setnutorder(message);
            alert_error(message);
        } else {
            setnutorder(json_faucet[lang]?.error_occurred); // Thay thế chuỗi cứng
            alert_error(json_faucet[lang]?.error_occurred); // Thay thế chuỗi cứng
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                window.location.href = info.redirect;
            }, 1700);
        }
    };

    return (
        <div className="mb-2 overflow-x-hidden w-full rounded-lg shadow-xl px-2 max-w-screen-xl mx-auto">
            <div className="mt-[2px] mb-[2px]">
                <Faucet_home />
            </div>
            <AdSense.Google
                client="ca-pub-4574266110812955"
                slot="1627514116"
                style={{ display: 'block', height: 100 }}
                format=""
            />
            <div className="flex flex-wrap justify-center">
            </div>
            <BitmediaAd />
            <div className="mb-[2px] flex justify-center items-center">
                {json_faucet[lang]?.level_up} {/* Thay thế chuỗi cứng */}
            </div>

            {data_edit && (
                <Mission_edit item={data_edit} data_edit={data_edit} set_data_edit={set_data_edit} />
            )}
            {
                (slug_2 == 'videos_check' || slug_2 == 'p2p_mmo') &&
                (<>
                    {/* <div class="flex justify-center mt-0 mb-1">
                        <div
                            className="inline-block px-6 py-2 rounded-full text-white text-base font-medium no-underline shadow-md transition bg-gradient-to-r from-pink-400 via-purple-400 to-indigo-400 hover:opacity-90"
                        >
                            Đang nâng cấp công nghệ, job nhiều như cũ vào ngày 5/10
                        </div>
                    </div> */}
                </>)
            }
            {!dalaythongtin ? (
                <div className="mt-2 flex justify-center items-center">
                    <MoonLoader size={75} color="#003AA5" />
                </div>
            ) : (
                <>
                    {data && (
                        <>
                            <div id="M882924ScriptRootC1520508"></div>
                            <Helmet>
                                <script src="https://jsc.adskeeper.com/h/u/hust.media.1520508.js" async></script>
                            </Helmet>
                            <div className="flex flex-wrap ">
                                <DataJop
                                    data={data}
                                    nutxuly={nutxuly}
                                    category={category}
                                    service={service}
                                    mission={mission}
                                    link={link}
                                    laymisson={laymisson}
                                    gtoken={gtoken}
                                    setgtoken={setgtoken}
                                    htoken={htoken}
                                    sethtoken={sethtoken}
                                    dataToSend={dataToSend}
                                    receiveDataFromChild={receiveDataFromChild}
                                    setnutxuly={setnutxuly}
                                    startjop={startjop}
                                    handleSubmit={handleSubmit}
                                    set_data_edit={set_data_edit}
                                    nutorder={nutorder}
                                />
                            </div>
                        </>
                    )}
                </>
            )}
        </div>
    );
}

export default Faucettraffic;
